<template>
  <Modal
    :id="'cmp-distribution-shops-sidewindow-add_shop_groups'"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("shop_groups")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <Dropdown
          :id="'shop_groups'"
          class="m2"
          :options="shopGroupsTV"
          :selected="shopGroupsTV.find(e => e.value == shop_group_id)"
          :placeholder="$t('tab_title_shop_groups')"
          box
          @selectedChange="e => onDropdownChange('shop_group_id', e)"
        ></Dropdown>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ShopsService } from "../../services/shops.service";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal
  },
  data() {
    return {
      unrelatedShopGroups: [],
      shop_group_id: ""
    };
  },
  mounted: async function() {
    const res = await ShopsService.newShopGroups(this.shop_id);
    this.unrelatedShopGroups = res.data.unrelated_shop_groups;
    // console.log("this.unrelatedShopGroups ", this.unrelatedShopGroups);
  },
  computed: {
    shop_id: function() {
      return this.$route.params.shop_id;
    },
    shopGroupsTV: function() {
      // console.log("unrelatedShopGroups ", this.unrelatedShopGroups);
      return createTV(
        this.unrelatedShopGroups,
        "shop_group_name",
        "shop_group_id"
      );
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function(name, value) {
      // <-- Normal Form Handling Methods
      // console.log("onDropdownChange ", name, value);
      this[name] = value.value;
    },

    onOkClick: async function() {
      const res = await ShopsService.submitShopGroup(
        this.shop_group_id,
        this.shop_id
      );
      this.$emit("added", res.data);
    }
  }
};
</script>
